exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".PatientConsentForMedicalRecordsExchange--1sBsm8_-0r_H7-vlFKfIMd {\n  height: 20px;\n  line-height: 20px;\n  text-transform: uppercase;\n  font-size: .8em;\n  cursor: pointer;\n}\n", ""]);

// exports
exports.locals = {
	"editButton": "PatientConsentForMedicalRecordsExchange--1sBsm8_-0r_H7-vlFKfIMd",
	"editButton": "PatientConsentForMedicalRecordsExchange--1sBsm8_-0r_H7-vlFKfIMd"
};